// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simplebar-scrollbar:before {
    position: absolute;
    content: '';
    background: rgba(238, 238, 238, 0.2);
    border-radius: 2px;
    width: 4px;
    left: 0px;
    right: 8px;
    opacity: 0;
    transition: opacity 0.2s 0.5s linear;
}
`, "",{"version":3,"sources":["webpack://./src/components/PickerList/styles.web.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,UAAU;IACV,oCAAoC;AACxC","sourcesContent":[".simplebar-scrollbar:before {\n    position: absolute;\n    content: '';\n    background: rgba(238, 238, 238, 0.2);\n    border-radius: 2px;\n    width: 4px;\n    left: 0px;\n    right: 8px;\n    opacity: 0;\n    transition: opacity 0.2s 0.5s linear;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
